// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".msg-screen{position:fixed;top:0;right:0;left:0;bottom:0;z-index:4;background-color:rgba(255,255,255,0.9);display:flex;align-items:center}.msg-screen__content{width:100%;max-width:600px;margin:0 auto}\n", ""]);
// Exports
module.exports = exports;
